// API 存取層
const BASE = '/api';

export const auth = {
  get token() { return localStorage.getItem('bf_token') || ''; },
  get user() {
    try { return JSON.parse(localStorage.getItem('bf_user')); } catch (e) { return null; }
  },
  save(token, user) {
    localStorage.setItem('bf_token', token);
    localStorage.setItem('bf_user', JSON.stringify(user));
  },
  clear() {
    localStorage.removeItem('bf_token');
    localStorage.removeItem('bf_user');
  },
};

async function req(method, url, body) {
  const opt = { method, headers: { 'Content-Type': 'application/json' } };
  if (auth.token) opt.headers['Authorization'] = 'Bearer ' + auth.token;
  if (body !== undefined) opt.body = JSON.stringify(body);
  const res = await fetch(BASE + url, opt);
  let data = null;
  try { data = await res.json(); } catch (e) { /* no body */ }
  if (res.status === 401 && !url.includes('/auth/login')) {
    auth.clear();
    if (window.location.pathname !== '/login') window.location.href = '/login';
    throw new Error('未登入或登入已過期');
  }
  if (!res.ok) {
    const msg = (data && data.error) || `請求失敗 (${res.status})`;
    throw new Error(msg);
  }
  return data;
}

export const api = {
  get: (url) => req('GET', url),
  post: (url, body) => req('POST', url, body || {}),
  put: (url, body) => req('PUT', url, body || {}),
  del: (url) => req('DELETE', url),
};

export const money = n => (Number(n) || 0).toLocaleString('zh-HK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const moneyInt = n => (Number(n) || 0).toLocaleString('zh-HK', { maximumFractionDigits: 2 });
export const fmtDate = s => s ? s.slice(0, 10).replaceAll('-', '/') : '—';
export const todayStr = () => new Date().toISOString().slice(0, 10);
export const addDays = (dateStr, days) => {
  const t = new Date(dateStr || todayStr());
  t.setDate(t.getDate() + days);
  return t.toISOString().slice(0, 10);
};
export const num = n => (Number(n) || 0);
export const r2 = n => Math.round((Number(n) || 0) * 100) / 100;

export const QT_STATUS = {
  draft: { label: '草稿', cls: 'st-gray' },
  sent: { label: '已發出', cls: 'st-blue' },
  accepted: { label: '已接受', cls: 'st-green' },
  rejected: { label: '已拒絕', cls: 'st-red' },
  converted: { label: '已轉訂單', cls: 'st-blue' },
  void: { label: '已作廢', cls: 'st-gray' },
};
export const ORDER_STATUS = {
  open: { label: '待處理', cls: 'st-amber' },
  in_progress: { label: '進行中', cls: 'st-blue' },
  completed: { label: '已完工', cls: 'st-green' },
  cancelled: { label: '已取消', cls: 'st-gray' },
};
export const INV_STATUS = {
  pending: { label: '待發送', cls: 'st-amber' },
  submitted: { label: '已發送', cls: 'st-blue' },
  partial: { label: '部分收款', cls: 'st-amber' },
  paid: { label: '已付清', cls: 'st-green' },
  void: { label: '已作廢', cls: 'st-gray' },
};
export const PO_STATUS = {
  draft: { label: '草稿', cls: 'st-gray' },
  issued: { label: '已發出', cls: 'st-blue' },
  received: { label: '已收貨', cls: 'st-green' },
  completed: { label: '已完成', cls: 'st-green' },
  cancelled: { label: '已取消', cls: 'st-gray' },
};
export const CATEGORIES = {
  INSTALLATION: { label: '安裝工程', en: 'INSTALLATION', icon: '🔧', cls: 'cat-ins' },
  MAINTENANCE: { label: '保養服務', en: 'MAINTENANCE', icon: '🛡️', cls: 'cat-mnt' },
  ECALL: { label: '緊急維修', en: 'E-CALL', icon: '🚨', cls: 'cat-ecl' },
  PROCUREMENT: { label: '採購', en: 'PROCUREMENT', icon: '📦', cls: 'cat-mnt' },
};
